<template>
  <v-row no-gutters class="pa-4" :class="color">
    <v-col cols="auto">
      <v-avatar color="white" :size="avatarSize">
        <v-img
          v-if="item.user && item.user.image_path"
          :src="conf.apiUrlBase + '/gallery/' + item.user.image_path"
          :max-height="avatarImgSize"
          :max-width="avatarImgSize"
        ></v-img>
        <span v-else>
          <div
            :style="{
              fontSize: initialsFontSize,
              lineHeight: 1,
            }"
            class="poppins-black primary--text"
          >
            {{ toLatin(getInitials(item.user)) }}
          </div>
          <div style="font-size: 12px" class="poppins-black">
            {{ item.user.id }}
          </div>
        </span>
      </v-avatar>
    </v-col>
    <v-col>
      <v-row justify="start" align="center" class="fill-height ml-2" no-gutters>
        <v-col
          :style="{
            lineHeight: 1 + settings.font.size.user / 400,
          }"
        >
          <p
            class="poppins-bold mb-2"
            :style="{ fontSize: userFontSize }"
            :class="[settings.font.uppercase ? 'text-uppercase' : '', textColor]"
          >
            {{ toLatin(item.user.name) }}
            {{ toLatin(item.user.lastname) }}
          </p>

          <div class="poppins-bold primary--text">
            {{ item.user.companies ? item.user.companies.at(0).name : "" }}
          </div>
        </v-col>
        <v-col cols="auto" class="fill-height" v-if="item.order?.shift">
          <v-chip class="shift-badge rounded-lg" :color="iconColor" label large>
            <span class="shift-roman primary--text"> {{ item.order.shift }}. </span>
            <span class="shift-label">{{ $t("shift.shift") }}</span>
          </v-chip>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import conf from "@/config";
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    settings: {
      type: Object,
    },
    textColor: {
      type: String,
      default: "white--text",
    },
    color: {
      type: String,
      default: "transparent",
    },
    iconColor: {
      type: String,
      default: "white",
    },
  },
  data() {
    return {
      conf,
    };
  },
  methods: {
    toRoman(value) {
      const map = ["I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX", "X"];
      const index = Number(value) - 1;
      return map[index] || String(value || "");
    },
    getInitials(user) {
      const firstInitial = user.name?.trim()?.charAt(0).toUpperCase() || "";
      const lastInitial = user.lastname?.trim()?.charAt(0).toUpperCase() || "";
      return this.toLatin(firstInitial + lastInitial);
    },
  },
  computed: {
    avatarSize() {
      if (this.device?.isMobile) return 48;
      if (this.device?.isTablet) return 64;
      return 76;
    },
    avatarImgSize() {
      if (this.device?.isMobile) return 40;
      if (this.device?.isTablet) return 54;
      return 60;
    },
    initialsFontSize() {
      if (this.device?.isMobile) return "20px";
      if (this.device?.isTablet) return "26px";
      return "32px";
    },
    userFontSize() {
      if (this.device?.isMobile) return (this.settings.font.size.user || 24) - 4 + "px";
      if (this.device?.isTablet) return "18px";
      return (this.settings.font.size.user || 24) + "px";
    },
  },
};
</script>

<style scoped>
.shift-badge {
  font-weight: 700;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.shift-roman {
  font-size: 32px;
  font-weight: 800;
  line-height: 1;
  margin-right: 6px;
}

.shift-label {
  font-size: 24px;
}

.v-chip {
  height: 40px;
}
</style>
